(function () {
  "use strict";

  var desktopStorageKey = "brCollectionGridMode";
  var mobileStorageKey = "brCollectionMobileGridMode";
  var desktopModes = ["editorial", "compact"];
  var mobileModes = ["small", "large"];
  var desktopQuery = window.matchMedia(
    "(min-width: 1000px) and (hover: hover) and (pointer: fine)",
  );
  var mobileQuery = window.matchMedia("(max-width: 767px)");
  var initialViewTracked = false;

  if (window.BRGridViewModeInitialized) return;
  window.BRGridViewModeInitialized = true;

  function isAllowedMode(mode, modes) {
    return modes.indexOf(mode) > -1;
  }

  function getStorageItem(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function setStorageItem(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {}
  }

  function trackGridViewMode(eventName, context, mode, source) {
    window.dataLayer = window.dataLayer || [];

    setStorageItem("brLastCollectionGridViewContext", context);
    setStorageItem("brLastCollectionGridViewMode", mode);
    setStorageItem("brLastCollectionGridViewSource", source);
    setStorageItem("brLastCollectionGridViewPath", window.location.pathname);
    setStorageItem("brLastCollectionGridViewTime", String(Date.now()));

    window.dataLayer.push({
      event: eventName,
      grid_view_context: context,
      grid_view_mode: mode,
      grid_view_source: source,
      page_type: "collection",
      page_path: window.location.pathname,
    });
  }

  function trackInitialView(context, mode) {
    if (initialViewTracked) return;

    initialViewTracked = true;
    trackGridViewMode("grid_view_mode_view", context, mode, "initial");
  }

  function getSavedDesktopMode() {
    var savedMode = getStorageItem(desktopStorageKey);
    return isAllowedMode(savedMode, desktopModes) ? savedMode : "compact";
  }

  function getSavedMobileMode() {
    var savedMode = getStorageItem(mobileStorageKey);
    return isAllowedMode(savedMode, mobileModes) ? savedMode : "small";
  }

  function getGridWrapper() {
    return document.querySelector("[data-collection-products]");
  }

  function getButtons(context) {
    return document.querySelectorAll(
      '[data-br-grid-toggle="' + context + '"] [data-grid-mode]',
    );
  }

  function updateButtons(context, mode) {
    getButtons(context).forEach(function (button) {
      button.setAttribute(
        "aria-pressed",
        button.getAttribute("data-grid-mode") === mode ? "true" : "false",
      );
    });
  }

  function clearGridModeClasses(gridWrapper) {
    gridWrapper.classList.remove(
      "br-grid-mode-editorial",
      "br-grid-mode-compact",
      "br-grid-mobile-small",
      "br-grid-mobile-large",
    );
  }

  function setDesktopMode(mode, shouldSave) {
    var gridWrapper = getGridWrapper();

    if (!gridWrapper || !isAllowedMode(mode, desktopModes)) return;

    clearGridModeClasses(gridWrapper);
    gridWrapper.classList.add("br-grid-mode-" + mode);

    if (shouldSave) {
      setStorageItem(desktopStorageKey, mode);
    }

    updateButtons("desktop", mode);
  }

  function setMobileMode(mode, shouldSave) {
    var gridWrapper = getGridWrapper();

    if (!gridWrapper || !isAllowedMode(mode, mobileModes)) return;

    clearGridModeClasses(gridWrapper);
    gridWrapper.classList.add("br-grid-mobile-" + mode);

    if (shouldSave) {
      setStorageItem(mobileStorageKey, mode);
    }

    updateButtons("mobile", mode);
  }

  function resetTabletMode() {
    var gridWrapper = getGridWrapper();

    if (!gridWrapper) return;

    clearGridModeClasses(gridWrapper);
    updateButtons("desktop", getSavedDesktopMode());
    updateButtons("mobile", getSavedMobileMode());
  }

  function applyCurrentMode() {
    var mode;

    if (desktopQuery.matches) {
      mode = getSavedDesktopMode();
      setDesktopMode(mode, false);
      trackInitialView("desktop", mode);
      return;
    }

    if (mobileQuery.matches) {
      mode = getSavedMobileMode();
      setMobileMode(mode, false);
      trackInitialView("mobile", mode);
      return;
    }

    resetTabletMode();
    trackInitialView("tablet", "default");
  }

  document.addEventListener("click", function (event) {
    var button = event.target.closest("[data-br-grid-toggle] [data-grid-mode]");

    if (!button) return;

    var toggle = button.closest("[data-br-grid-toggle]");
    var context = toggle.getAttribute("data-br-grid-toggle");
    var mode = button.getAttribute("data-grid-mode");

    event.preventDefault();

    if (context === "desktop") {
      if (!isAllowedMode(mode, desktopModes)) return;
      setDesktopMode(mode, true);
      trackGridViewMode("grid_view_mode_change", "desktop", mode, "click");
      return;
    }

    if (context === "mobile") {
      if (!isAllowedMode(mode, mobileModes)) return;
      setMobileMode(mode, true);
      trackGridViewMode("grid_view_mode_change", "mobile", mode, "click");
    }
  });

  function bindMediaQuery(query) {
    if (query.addEventListener) {
      query.addEventListener("change", applyCurrentMode);
    } else if (query.addListener) {
      query.addListener(applyCurrentMode);
    }
  }

  document.addEventListener("shopify:section:load", applyCurrentMode);
  bindMediaQuery(desktopQuery);
  bindMediaQuery(mobileQuery);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyCurrentMode);
  } else {
    applyCurrentMode();
  }
})();
